(function () {
  /* Interactieve onderdelen van de modelpagina: voertuigverkenner, scherm in beeld en verhaal dat meebeweegt. */
  if (window.__swInteractive) return;
  window.__swInteractive = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Voertuigverkenner */
  function dotsOf(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-exp-dot]')); }

  function restartBar(root) {
    root.querySelectorAll('.sw-mexp__bar span').forEach(function (bar) {
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
    });
  }

  function setExplorer(root, id, zoomIn) {
    var active = null;
    dotsOf(root).forEach(function (dot) {
      var on = dot.getAttribute('data-exp-dot') === id;
      if (on) active = dot;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-exp-row]').forEach(function (row) {
      var on = row.getAttribute('data-exp-row') === id;
      row.classList.toggle('is-active', on);
      if (on) row.setAttribute('aria-current', 'true'); else row.removeAttribute('aria-current');
    });
    root.querySelectorAll('[data-exp-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-exp-panel') !== id;
    });
    var view = root.querySelector('[data-exp-view]');
    var stage = root.querySelector('[data-exp-stage]');
    var wrap = root.querySelector('.sw-mexp__render');
    var zoom = parseFloat(root.getAttribute('data-zoom')) || 1;
    if (view && stage) {
      if (zoomIn && zoom > 1 && active && wrap && !reduce && window.innerWidth >= 750) {
        var ox = wrap.offsetLeft + active.offsetLeft;
        var oy = wrap.offsetTop + active.offsetTop;
        view.style.transformOrigin = ox + 'px ' + oy + 'px';
        view.style.transform = 'scale(' + zoom + ')';
        stage.style.setProperty('--zoom', zoom);
      } else {
        view.style.transform = '';
        stage.style.setProperty('--zoom', 1);
      }
    }
    restartBar(root);
  }

  function stepExplorer(root, dir) {
    var dots = dotsOf(root);
    if (!dots.length) return;
    var current = 0;
    dots.forEach(function (d, i) { if (d.classList.contains('is-active')) current = i; });
    var next = (current + dir + dots.length) % dots.length;
    setExplorer(root, dots[next].getAttribute('data-exp-dot'), true);
  }

  function stopTour(root) {
    if (root.__tour) { window.clearInterval(root.__tour); root.__tour = null; }
    root.classList.remove('is-touring');
  }

  function startTour(root) {
    if (root.__tour || root.__user || reduce) return;
    if (root.getAttribute('data-autoplay') !== 'true') return;
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    root.style.setProperty('--sw-int', (ms / 1000) + 's');
    root.classList.add('is-touring');
    restartBar(root);
    root.__tour = window.setInterval(function () { stepExplorer(root, 1); }, ms);
  }

  function initExplorers() {
    document.querySelectorAll('[data-sw-exp]').forEach(function (root) {
      if (root.__swInit) return;
      root.__swInit = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startTour(root);
            else stopTour(root);
          });
        }, { threshold: 0.45 }).observe(root);
      }
      root.addEventListener('mouseenter', function () { stopTour(root); });
      root.addEventListener('mouseleave', function () { startTour(root); });
    });
  }

  /* Scherm in beeld */
  function setScreen(root, id) {
    root.querySelectorAll('[data-scr-tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-scr-tab') === id;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });
    root.querySelectorAll('[data-scr-view]').forEach(function (view) {
      view.classList.toggle('is-active', view.getAttribute('data-scr-view') === id);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var pick = target.closest('[data-exp-dot], [data-exp-row]');
    if (pick) {
      var expRoot = pick.closest('[data-sw-exp]');
      if (expRoot) {
        expRoot.__user = true;
        stopTour(expRoot);
        setExplorer(expRoot, pick.getAttribute('data-exp-dot') || pick.getAttribute('data-exp-row'), true);
      }
      return;
    }
    var tab = target.closest('[data-scr-tab]');
    if (tab) {
      var scrRoot = tab.closest('[data-sw-scr]');
      if (scrRoot) setScreen(scrRoot, tab.getAttribute('data-scr-tab'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target && event.target.closest ? event.target.closest('[data-scr-tab]') : null;
    if (!tab) return;
    var keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'];
    if (keys.indexOf(event.key) === -1) return;
    event.preventDefault();
    var root = tab.closest('[data-sw-scr]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-scr-tab]'));
    var i = tabs.indexOf(tab);
    var next = (event.key === 'ArrowDown' || event.key === 'ArrowRight') ? i + 1 : i - 1;
    next = (next + tabs.length) % tabs.length;
    tabs[next].focus();
    setScreen(root, tabs[next].getAttribute('data-scr-tab'));
  });

  /* Verhaal dat meebeweegt */
  function initScrolly() {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-sw-scrolly]').forEach(function (root) {
      if (root.__swInit) return;
      root.__swInit = true;
      var steps = root.querySelectorAll('[data-sc-step]');
      var media = root.querySelectorAll('[data-sc-media]');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = entry.target.getAttribute('data-sc-step');
          steps.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-sc-step') === index); });
          media.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-sc-media') === index); });
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach(function (step) { observer.observe(step); });
    });
  }

  function initAll() { initExplorers(); initScrolly(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
